module.exports = __webpack_public_path__ + "544be158edff368e7970c9247dd1079f.pdf";